module.exports = __webpack_public_path__ + "img/bs_map.933e116d.png";